import { trackLinkClick } from 'utils/tracking';
import Links from '@/components/ui/Links';
import { Page_Pagebuilder_Blocks_Texteditor } from '@/graphql/generated/graphql';
import { m } from 'motion/react';
import { containerVariants, viewPort } from 'utils/framer';
import { getContainerClass } from 'utils/helpers';
import Wysiwyg from '../components/dom-parser';

const Texteditor = ({
  blockId,
  content,
  containerWidth,
  bgColor,
  links,
}: Page_Pagebuilder_Blocks_Texteditor) => {
  if (!content) return null;
  return (
    <m.section
      initial="hidden"
      whileInView="visible"
      viewport={viewPort}
      variants={containerVariants}
      id={blockId ?? undefined}
      className="w-full my-14 lg:my-24"
    >
      <div
        className={`w-full ${getContainerClass(containerWidth)} ${bgColor ? 'p-4' : ''}`}
        style={{ backgroundColor: bgColor ? bgColor : 'transparent' }}
      >
        <div className="editor px-4 md:px-0">
          <Wysiwyg>{content}</Wysiwyg>
        </div>

        <Links links={links} onLinkClick={trackLinkClick} />
      </div>
    </m.section>
  );
};

export default Texteditor;
